import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { School, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [
  ["director_name", "Nome do(a) diretor(a)", "text"],
  ["whatsapp_director", "WhatsApp do(a) diretor(a)", "tel"],
  ["phone", "Telefone da escola", "tel"],
  ["email", "E-mail da escola", "email"],
  ["director_email", "E-mail do(a) diretor(a)", "email"],
  ["cnpj", "CNPJ da APM/escola (nota fiscal)", "text"],
  ["cep", "CEP", "text"],
  ["address", "Endereço (rua)", "text"],
  ["address_number", "Número", "text"],
  ["neighborhood", "Bairro", "text"],
];

export default function SchoolContactsDialog({ open, onOpenChange, school, onSaved }) {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && school) setForm(Object.fromEntries(FIELDS.map(([k]) => [k, school[k] || ""])));
  }, [open, school]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/schools/${school.id}/contacts`, form);
      toast.success("Contatos da escola atualizados");
      onOpenChange(false);
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao salvar");
    } finally { setSaving(false); }
  };

  if (!school) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="school-contacts-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><School className="w-5 h-5 text-[#1e3a8a]" /> Dados da escola</DialogTitle>
          <DialogDescription className="text-xs break-words">{school.name}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {FIELDS.map(([k, label, type]) => (
            <div key={k} className="space-y-1">
              <Label className="text-xs font-semibold text-slate-600">{label}</Label>
              <Input type={type} value={form[k] || ""} onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} data-testid={`school-contact-${k}`} />
            </div>
          ))}
          <Link to={`/escolas/${school.id}`} className="inline-flex items-center gap-1 text-xs font-semibold text-[#7c3aed] hover:underline" data-testid="link-school-full-form">
            <ExternalLink className="w-3 h-3" /> Abrir cadastro completo da escola
          </Link>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={save} disabled={saving} className="bg-[#1e3a8a] hover:bg-[#1e40af] text-white" data-testid="btn-save-school-contacts">{saving ? "Salvando..." : "Salvar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
